import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { loadingSkeletonKeyframes } from '@pkg/motion';

export const GroupItemAvatar = styled.div<{ isPrivate: boolean }>`
    position: relative;

    width: 60px;
    height: 60px;

    display: flex;
    align-items: center;
    justify-content: center;

    ${({ isPrivate }) =>
        isPrivate &&
        css`
            ${GroupItemAvatarBadgeElement} {
                bottom: -4px;
            }
        `};
`;

export const GroupItemAvatarImage = styled.div<{ avatarUrl: string }>`
    width: 100%;
    height: 100%;
    border-radius: 100px;
    overflow: hidden;

    ${({ avatarUrl }) => css`
        background-image: url(${avatarUrl});
    `};

    background-size: cover;
    background-position: center center;
`;

export const GroupItemAvatarBackground = styled.div`
    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }

    width: 60px;
    height: 60px;
    border-radius: 50%;
    z-index: 0;
    position: absolute;
    top: 0;
    background: linear-gradient(30deg, #7000ff 0%, #7000ff 30%, #fa06ff 50%, #7000ff 70%, #7000ff 100%);
    animation: rotate 12s linear infinite;
`;

export const GroupItemAvatarBadgeElement = styled.div<{ type: 'owner' | 'member' }>`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: -2px;
    right: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: linear-gradient(180deg, #686080 0%, #2a2637 100%);
    border: 2px solid #090618;
    z-index: 2;

    ${({ type }) =>
        type === 'owner' &&
        css`
            background: linear-gradient(180deg, #6e3ef4 0%, #2d17b8 100%);
        `};
`;

export const GroupItemBadges = styled(motion.div)`
    position: absolute;
    bottom: 0;
    left: 16px;
    right: 0;
    display: flex;
    flex-direction: row;
    gap: 8px;
    margin-top: 4px;
    pointer-events: none;
`;

export const GroupItemInfoText = styled(motion.div)``;

export const GroupItemName = styled.div`
    font-weight: 600;
    font-size: 18px;
    line-height: 20px;
    letter-spacing: -0.03em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 190px;
`;

export const GroupItemAvatarPlaceholder = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 24px !important;
        height: 24px !important;
        opacity: 0.6;

        @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
            margin-left: -5px;
        }
    }
`;

export const GroupItemAvatarHolder = styled.div<{ isPrivate: boolean }>`
    background-color: #222030;
    border-radius: 100px;
    user-select: none;
    position: relative;
    z-index: 1;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 60px;
    height: 60px;

    ${({ isPrivate }) =>
        isPrivate &&
        css`
            border: 2px solid #090618;
            width: 56px;
            height: 56px;
        `};
`;

type GroupItemAvatarSkeletonProps = {
    $loading?: boolean;
};

export const GroupItemAvatarSkeleton = styled.div<GroupItemAvatarSkeletonProps>`
    width: 60px;
    height: 60px;
    position: relative;
    background: #ffffff;
    opacity: 0.05;
    border-radius: 100px;
    flex-shrink: 0;
    ${({ $loading }) =>
        $loading &&
        css`
            animation: ${loadingSkeletonKeyframes} 1.5s linear infinite;
        `}
`;
